
import {Table} from '@baidu/luffy-comp-table';
export type {TableCol, TableRow} from '@baidu/luffy-comp-table';
export default Table;
